module.exports = {
  favorites: [
    {
      name: "Call of Duty®: Ghosts",
      imageURL: "https://store-images.s-microsoft.com/image/apps.39870.71126192909217923.0a970f54-6910-47b8-93b8-842de1476b5b.855d7022-9890-428c-b6a3-089bdf6a00d9?mode=scale&q=90&h=300&w=200",
    },
    {
      name: "Halo: The Master Chief Collection",
      imageURL: "https://store-images.s-microsoft.com/image/apps.13367.13817186670444302.148c432a-9fce-4c7d-bf13-8a2bd3a527b3.f26b74f0-8b1f-41eb-a82f-06843ec33473",
    },
    {
      name: "Far Cry® 5",
      imageURL: "https://store-images.s-microsoft.com/image/apps.11227.69582963086497758.e1cff2e3-ddf1-42bf-930d-f380ad63f100.38d7bb7c-3e33-471b-b22d-0f0a635832ad",
    },
    {
      name: "Battlefield™: Hardline",
      imageURL: "https://store-images.s-microsoft.com/image/apps.54948.63735777037085446.8fe8dc26-04d3-4d1f-9c78-cbcd6784657d.eda99f52-e778-4fe8-9355-2007a3985e1e?mode=scale&q=90&h=300&w=200",
    },
    {
      name: "Tom Clancy's Ghost Recon® Wildlands",
      imageURL: "https://store-images.s-microsoft.com/image/apps.16447.65577870102127192.24a0a154-ded1-4a40-a91f-102019aaee70.9315ae41-3fbe-4f1f-a91b-5049d566842f?mode=scale&q=90&h=300&w=200",
    },
    {
      name: "Far Cry® 3",
      imageURL: "https://store-images.s-microsoft.com/image/apps.33719.71220804959101191.bad88979-60b4-40b4-af6d-182d4534c987.ecf3220f-0497-4cf1-9cee-d46d9d86ecc3?mode=scale&q=90&h=300&w=200",
    },
    {
      name: "Minecraft",
      imageURL: "https://store-images.s-microsoft.com/image/apps.17382.13510798887677013.afcc99fc-bdcc-4b9c-8261-4b2cd93b8845.49beb011-7271-4f15-a78b-422c511871e4",
    },
    {
      name: "Call of Duty®: Modern Warfare Remastered",
      imageURL: "https://store-images.s-microsoft.com/image/apps.64815.69193298161071220.7c147b76-ab45-48fc-95ce-70c11df6b921.ba77bc1a-caca-4216-bca2-00eef00deef1?mode=scale&q=90&h=300&w=200",
    },
    {
      name: "Tomb Raider",
      imageURL: "https://store-images.s-microsoft.com/image/apps.35283.68847167288522183.9fdea778-258f-40d6-9f9e-fab92915bc6d.98c2dd25-9180-49e5-bdd3-6bdb1d857889?mode=scale&q=90&h=300&w=200",
    },
    {
      name: "Battlefield 4™",
      imageURL: "https://store-images.s-microsoft.com/image/apps.1392.67660042887481018.7de2bfcd-48ef-4a6c-bba4-e65d208d67ec.d712d519-5ad0-4aac-9271-ad4424fd3702?mode=scale&q=90&h=300&w=200",
    },
    {
      name: "Tom Clancy's Ghost Recon® Breakpoint",
      imageURL: "https://store-images.s-microsoft.com/image/apps.42343.66828190550422385.db1e8db2-3853-42e9-b3d4-23771b4cf668.20c30a66-8ec1-454f-a09c-d277f38f4c76",
    },
    {
      name: "Call of Duty®: WWII",
      imageURL: "https://store-images.s-microsoft.com/image/apps.26312.70628478259232551.a0089f3a-b3b5-4c4b-bdaf-0d97810a4816.772b3a20-259a-4178-be6f-3db7bcdc9830?mode=scale&q=90&h=300&w=200",
    },
    {
      name: "Watch Dogs®",
      imageURL: "https://store-images.s-microsoft.com/image/apps.51441.66583679601418453.329e8674-c508-4106-8a82-e4ebbbda5bd7.d28372d0-95e3-4c53-aa88-43909b44308f?mode=scale&q=90&h=300&w=200",
    },
    {
      name: "Halo 5: Guardians",
      imageURL: "https://store-images.s-microsoft.com/image/apps.10920.69279545232152045.f1a4a87c-fcc9-4b7c-a620-f6c56eb2d5ad.537d404f-d551-430c-8000-9a4c657bf354?mode=scale&q=90&h=300&w=200",
    },
    {
      name: "Tom Clancy's The Division®",
      imageURL: "https://store-images.s-microsoft.com/image/apps.54587.69731494251073459.b4784411-abd2-44d3-85f2-ee9462429806.a6c5b771-10e0-4c87-ac93-d2a6a85a467c?mode=scale&q=90&h=300&w=200",
    },
    {
      name: "F1™ 2015",
      imageURL: "https://store-images.s-microsoft.com/image/apps.6207.69301240788346750.e5150c02-2bc8-4179-8b86-330ac9362f56.5ea0a9c5-d47e-400e-83f0-7ec9f1febcaf?mode=scale&q=90&h=300&w=200",
    },
    {
      name: "Call of Duty®: Black Ops 4",
      imageURL: "https://store-images.s-microsoft.com/image/apps.62553.63686339552071591.ae7ee088-c1d7-421b-8368-10451cd63360.1287229a-8a9d-457a-822a-8bd05e94b148?mode=scale&q=90&h=300&w=200&background=%23FFFFFF",
    },
    {
      name: "Rise of The Tomb Raider",
      imageURL: "https://store-images.s-microsoft.com/image/apps.20532.67345955710459827.6770a7a0-cc7f-4a09-ae17-dc0da389809a.f565a0bf-8bf9-4648-a658-b93b7a09fa69?mode=scale&q=90&h=300&w=200&background=%23FFFFFF",
    },
    {
      name: "The Witcher 3: Wild Hunt",
      imageURL: "https://store-images.s-microsoft.com/image/apps.28990.69531514236615003.8f0d03d6-6311-4c21-a151-834503c2901a.d629260e-2bc4-4588-950c-f278cbc22a64?mode=scale&q=90&h=300&w=200",
    },
    {
      name: "Tom Clancy's The Division® 2",
      imageURL: "https://store-images.s-microsoft.com/image/apps.40002.71050925055292780.84669981-d249-4abc-83d1-890677ca1659.3bb7551a-dc57-4f03-81df-18e57f456dc5",
    },
    {
      name: "Call of Duty®: Advanced Warfare",
      imageURL: "https://store-images.s-microsoft.com/image/apps.14483.67165690531218804.13d83797-84d4-446f-b916-765bfa2132cf.efd4b7ef-ae95-4e76-b27e-5746898127cf?mode=scale&q=90&h=300&w=200",
    },
    {
      name: "Rocket League®",
      imageURL: "https://store-images.s-microsoft.com/image/apps.32824.65187692735347017.53e8415a-898d-4306-ba68-1d6e9b47d1fb.c85fed89-7a87-4fd2-bb39-1421d6c8c3db?mode=scale&q=90&h=300&w=200",
    },
    {
      name: "Metal Gear V: The Phantom Pain",
      imageURL: "https://store-images.s-microsoft.com/image/apps.24111.65806558541457305.a0ff0982-eced-4bfd-bb78-5ba7a73376c4.8173048f-456f-4928-bfcc-268f5002a41c?mode=scale&q=90&h=300&w=200",
    },
    {
      name: "Far Cry® 6",
      imageURL: "https://store-images.s-microsoft.com/image/apps.41566.14333025555296848.2ada7e2e-1c33-443c-8dbe-9b5385ed77ee.48761a08-0131-40bb-b88d-40a8fe440076?mode=scale&q=90&h=300&w=200&background=%23FFFFFF",
    },
    {
      name: "A Plague Tale: Innocence",
      imageURL: "https://store-images.s-microsoft.com/image/apps.14356.68306748966338141.e6f96fac-aa67-4f59-9043-10654607aa79.aa73acc4-f944-4ab1-83c3-265506b1529d?mode=scale&q=90&h=300&w=200",
    },
    {
      name: "Gears 5",
      imageURL: "https://store-images.s-microsoft.com/image/apps.10933.65494054591008504.4eae27ba-1cfe-4af2-950a-4af81f8cd22a.b5b2909d-8884-48d0-b25a-68d6518c9b73",
    },
    {
      name: "Call of Duty®: Modern Warfare",
      imageURL: "https://store-images.s-microsoft.com/image/apps.50528.68332208580498659.9222b095-8101-4531-b386-33547ee9944f.948f2c50-2f29-43df-9557-4670f69840d1",
    },
    {
      name: "Just Cause 3",
      imageURL: "https://store-images.s-microsoft.com/image/apps.23008.64522152845233115.df5684f8-3402-4f04-92ba-3685f010c2e0.96343dd8-1c14-4e44-b221-6f8350168b11?mode=scale&q=90&h=300&w=200&background=%23FFFFFF",
    },
    {
      name: "Doom",
      imageURL: "https://store-images.s-microsoft.com/image/apps.18860.66773763610413114.5c7115ed-b566-4d24-80ce-7027cb5b7c3e.e1d91fd3-d9ed-4be4-aedf-437e5d9820fe?mode=scale&q=90&h=300&w=200",
    },
    {
      name: "The Crew®",
      imageURL: "https://store-images.s-microsoft.com/image/apps.45553.67349599014244989.aa237ee4-1eed-4499-8ed6-a1e95c7130f3.c9a27003-dd27-45ab-8ac7-81ea6621885d?mode=scale&q=90&h=300&w=200",
    },
    {
      name: "Assassin's Creed® Valhalla",
      imageURL: "https://store-images.s-microsoft.com/image/apps.1547.14585440003614248.9f7109bf-73f7-4bc7-ba61-1eeb006d905a.75930d81-6e85-436d-9b61-1279b8dd9b31",
    },
    {
      name: "Call of Duty®: Warzone",
      imageURL: "https://store-images.s-microsoft.com/image/apps.50156.13835473807186336.f6be677f-38d1-4188-aab7-471cf0199ee6.2078e3ea-f72b-4fc4-8c42-30477a8f72fc",
    },
    {
      name: "Grand Theft Auto V",
      imageURL: "https://store-images.s-microsoft.com/image/apps.32034.68565266983380288.0f5ef871-88c0-45f7-b108-6aacbc041fcf.9b094362-c51d-49e5-9e92-80710c585fca?mode=scale&q=90&h=300&w=200",
    },
    {
      name: "Watch Dogs® 2",
      imageURL: "https://store-images.s-microsoft.com/image/apps.26142.69997608528322872.06dc9610-5c4e-484e-b028-58ad215e637a.b216af15-301f-4f23-83a3-69a59a87985b?mode=scale&q=90&h=300&w=200",
    },
    {
      name: "Assassin’s Creed® Odyssey",
      imageURL: "https://store-images.s-microsoft.com/image/apps.51903.71972716530068101.ccdcadf1-1d2a-49f2-9c37-0b0a27e5a53c.08e06d2d-1104-4c80-b879-91facf8348d5",
    },
    {
      name: "NARUTO SHIPPUDEN™: Ultimate Ninja® STORM 4",
      imageURL: "https://store-images.s-microsoft.com/image/apps.11388.64948385422045442.fc5518ac-d506-4b26-8e08-6bb267328027.5b2ce1b8-6011-4dbd-ae0f-6fbcf3af7875?mode=scale&q=90&h=300&w=200",
    },
  ],
};